module.exports = __webpack_public_path__ + "static/media/img-gear.b62a2661.svg";